import React from 'react'
import Button from '@/Components/Button'
import { formatPrice } from '../utils/formatters'

export default function UpsellBanner({ upsell, isInBasket, onAdd }) {
  if (!upsell || isInBasket) return null

  const { cta_title, menu_item } = upsell

  return (
    <div className="bg-white rounded-xl p-4 mb-6 shadow-sm" role="complementary" aria-label="Suggested add-on">
      <div className="flex items-center gap-4">
        {menu_item.image_url && (
          <img
            src={menu_item.image_url}
            alt={menu_item.name}
            className="w-16 h-16 rounded-lg object-cover flex-shrink-0"
          />
        )}
        <div className="flex-1 min-w-0">
          <p className="text-base font-bold text-gray-900">{cta_title}</p>
          <p className="text-sm text-gray-500">
            {menu_item.name} &middot; {formatPrice(menu_item.price_pence)}
          </p>
        </div>
      </div>
      <Button
        onClick={() => onAdd(menu_item)}
        theme="dark"
        size="sm"
        fullWidth
        className="mt-3"
      >
        + Add to order
      </Button>
    </div>
  )
}
